module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS2.5b255ed5.jpg";